module.exports = __webpack_public_path__ + "static/media/logo-white-main.32b8894d.png";